import * as React from 'react';
import { ContextStore, RouteStore } from 'bernie-core';
// mobx
import { inject } from 'mobx-react';

import { UiStore } from 'stores';
import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkIcon } from 'uitk-react-icons';
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuList, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkText } from 'uitk-react-text';

export interface LanguageSelectorProps {
  uiStore?: UiStore;
  routeStore?: RouteStore;
  context?: ContextStore;
}

export const LanguageSelector: React.FunctionComponent<LanguageSelectorProps> = inject(
  'uiStore',
  'routeStore',
  'context',
)(({ uiStore, routeStore, context }) => {
  const { supportedLocales } = uiStore;
  const currentLang =
    supportedLocales &&
    supportedLocales.find((locale) => {
      return locale.langId === context.langId;
    });

  React.useEffect(() => {
    const storedLocale = localStorage.getItem('locale');
    if (!storedLocale || context.locale !== storedLocale) {
      localStorage.setItem('locale', context.locale);
    }
  }, []);

  // Set state
  const [activeLabel, setActiveLabel] = React.useState(currentLang.langLabel);
  const [open, setOpen] = React.useState(false);

  let pathWithoutLocale: string;
  let path: string;

  // Do this for every page other than the first homepage load
  if (routeStore.pathname !== '/home') {
    // Get path from the route, strip out locale
    const pathArray = routeStore && routeStore.pathname.split('/');
    const param = routeStore && routeStore.search;

    if (pathArray) {
      // take out first pieces of URL '' and '/xx-xx/'
      pathArray.splice(0, 2);
      pathWithoutLocale = pathArray && pathArray.join('/');
    }

    path = param ? pathWithoutLocale + param : pathWithoutLocale;
    // Homepage starts without locale prefix so don't try remove
  } else {
    path = 'home';
  }

  const langList =
    supportedLocales &&
    supportedLocales.map((lang, i) => {
      return {
        attributes: {
          role: 'menuitem',
          tabindex: i + 1,
        },
        label: lang.langLabel,
        className: 'uitk-list-item',
        href: `/${lang.langCode}/${path}`,
        typeAnchor: true,
        onClick: (e) => handleItemClick(e, lang.langLabel),
      };
    });

  function handleItemClick(e, label) {
    setActiveLabel(label);
    setOpen(false);
  }

  function handleTriggerClicked(e) {
    setOpen(!open);
  }

  return (
    <UitkMenu isOpen={open} onTriggerClick={(e) => handleTriggerClicked(e)}>
      <UitkMenuTrigger>
        <UitkTertiaryButton>
          <UitkIcon name="language" />
          <UitkText size={300} className="hidden-mobile">
            {activeLabel}
          </UitkText>
        </UitkTertiaryButton>
      </UitkMenuTrigger>
      <UitkMenuContainer position={PositionType.RIGHT}>
        <UitkMenuList items={langList} />
      </UitkMenuContainer>
    </UitkMenu>
  );
});
